import type { ReportForList } from '@/types/reports';

export function sortReportsByDateDesc(reports: ReportForList[]): ReportForList[] {
  return [...reports].sort((a, b) => {
    const dateA = a.updatedAt?.getTime?.() ?? a.createdAt.getTime();
    const dateB = b.updatedAt?.getTime?.() ?? b.createdAt.getTime();
    return dateB - dateA;
  });
}
